<div class="main-div">
    <div class="header"> Confirmation </div>
    <p class="text-div">
        The file <b> {{fileName}} </b> already exists. 
        Do you want to replace it?</p>
    <div class="button-div">
        <button mat-flat-button color="warn" class="replaceButton" (click)="onReplaceClick()"> Replace</button>
        <button mat-flat-button color="warn" class="cancelButton" (click)="onCancelClick()"> Cancel</button>
    </div>
</div>